import { mockApiAdminHandlers } from './mock-api-admin.handlers';
import { mockApiAuthHandlers } from './mock-api-auth.handlers';
import { mockApiHealthHandlers } from './mock-api-health.handlers';
import { mockApiPlatformUsersHandlers } from './mock-api-platform-users.handlers';
import { mockApiPropertyMatrixHandlers } from './mock-api-property-matrix.handlers';
import { mockApiPublicCatalogHandlers } from './mock-api-public-catalog.handlers';

import { Observable, of } from 'rxjs';

import { HttpRequest, HttpResponse } from '@angular/common/http';

/**
 * Ponto de registro de handlers de mock. Rotas reais de negócio entram aqui no futuro.
 * Ordem: health e auth primeiro; público antes do admin; `/api/demo-mock/health` é legado de smoke local.
 */
export type MockRequestHandler = {
  method: string;
  path: string | RegExp;
  handle: (req: HttpRequest<unknown>, pathMatch: RegExpMatchArray | null) => Observable<HttpResponse<unknown>>;
};

/** Pathname de pedido, sem query, para alinhar handler e respostas de “sem mock”. */
export function resolveMockApiPathname(url: string): string {
  if (url.startsWith('http://') || url.startsWith('https://'))
    return new URL(url).pathname;

  return url.split('?')[0] ?? url;
}

export const mockApiRequestHandlers: MockRequestHandler[] = [
  ...(mockApiHealthHandlers as MockRequestHandler[]),
  ...(mockApiAuthHandlers as MockRequestHandler[]),
  ...(mockApiPublicCatalogHandlers as MockRequestHandler[]),
  ...(mockApiPropertyMatrixHandlers as MockRequestHandler[]),
  ...(mockApiPlatformUsersHandlers as MockRequestHandler[]),
  ...(mockApiAdminHandlers as MockRequestHandler[]),
  {
    method: 'GET',
    path: '/api/demo-mock/health',
    handle: (_req, _match) =>
      of(
        new HttpResponse({
          body: { status: 'ok' },
          status: 200,
        }),
      ),
  },
];

export function matchMockApiRequest(
  req: HttpRequest<unknown>,
): ReturnType<MockRequestHandler['handle']> | null {
  const path = resolveMockApiPathname(req.url);
  for (const h of mockApiRequestHandlers) {
    if (h.method !== req.method)
      continue;

    if (typeof h.path === 'string') {
      if (h.path !== path)
        continue;

      return h.handle(req, null);
    }

    const m = path.match(h.path);

    if (m == null)
      continue;

    return h.handle(req, m);
  }

  return null;
}
